// packages/storefront/src/storefrontEnv.ts
//
// What the storefront tree needs to know about the build it runs in. The bundle that mounts it says so once,
// before mounting: the embed's entries from CRA's `REACT_APP_*` (inlined at build time, `entries/embedBuildEnv.ts`),
// and a TourTask site's island from its own build. Nothing in the tree reads `process.env` itself, because a Next
// client bundle does not fill `REACT_APP_*` (docs/website-builder/design/storefront.md §2.1).

export interface StorefrontEnv {
	/** The deployed commit, in the build marker and in every error report; `dev` for a local build. */
	buildId: string;
	/** Load PayPal's sandbox SDK instead of the live one (`REACT_APP_PAYPAL_SANDBOX=true` on a test build). */
	paypalSandbox: boolean;
	/**
	 * Preload Stripe.js on every page of the shop, for a business that may take payments in it
	 * (`hooks/usePreloadStripeJs.ts`): the widget, where Stripe's fraud signals then cover the whole visit. A TourTask
	 * site keeps it off its catalogue pages, and its booking page loads it.
	 */
	preloadStripeJsWhileBrowsing: boolean;
}

/**
 * What a local build without any of the variables is: the values the reads had before this module existed. No
 * Stripe.js preload, which only a bundle that mounts the shop asks for.
 */
const LOCAL_BUILD: StorefrontEnv = { buildId: 'dev', paypalSandbox: false, preloadStripeJsWhileBrowsing: false };

let current: StorefrontEnv = LOCAL_BUILD;

/** Called by the bundle that mounts the storefront, before it mounts. */
export function setStorefrontEnv(env: StorefrontEnv): void {
	current = env;
}

export function storefrontEnv(): StorefrontEnv {
	return current;
}
